<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["ASN"]["ANSN"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="closeAdd">
                                            <CIcon name="cilX"></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol md="6" class="form-group">
                                        <label class="col-form-label-sm">{{this.getLanguage['ASN']['ST']}}<span class="required" /> :</label>
                                        <customtreeselect :multiple="true"
                                                          :options="dd_agentgroup"
                                                          :flat="false"
                                                          :limit="1"
                                                          :defaultExpandLevel="Infinity"
                                                          :clearable="false"
                                                          :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                          :disabled="bool_isEdit || bool_SentAll"
                                                          v-model="obj_aa['AGIT']"
                                                          ref="AGIT" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('AGIT','ST') }}</span>
                                    </CCol>
                                    <CCol md="6" v-if="obj_aa.I != 0">
                                        <label class="col-form-label-sm" style="margin-right: 20px;">{{this.getLanguage["ASN"]["SA"]}} :</label><br>
                                        <label class="switch">
                                            <input :checked="bool_SentAll" @change="v => bool_SentAll = v.target.checked" type="checkbox" />
                                            <span class="slider round"></span>
                                        </label>
                                    </CCol>

                                </CRow>
                                <CRow>
                                    <CCol md="6">
                                        <label class="col-form-label-sm">{{this.getLanguage['ASN']['NT']}}<span class="required" /> :</label>
                                        <span class="WCMsg" v-if="this.obj_aa.T != null">{{ this.obj_aa.T.length }} / 200 </span>
                                        <span class="WCMsg" v-else> 0 / 200 </span>
                                        <CInput maxlength="200" vertical size="sm" :value="obj_aa.T" @change="v => obj_aa.T = v" :disabled="bool_isEdit" ref="T" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('T','NT') }}</span>
                                    </CCol>

                                </CRow>

                                <CRow>
                                    <CCol>
                                        <label class="col-form-label-sm">{{this.getLanguage['ASN']['NC']}}<span class="required" /> :</label>
                                        <textarea vertical="" rows="6" class="form-control form-control-sm" :disabled="bool_isEdit" :value="obj_aa.CBD" @change="TextValueChange('CBD',$event)" v-shortkey.avoid ref="CBD" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('CBD','NC') }}</span>
                                    </CCol>
                                </CRow>

                                <div style="text-align:center">
                                    <CButton v-if="!bool_isEdit"
                                             color="outline-info"
                                             size="sm"
                                             style="margin-top:20px"
                                             @click="saveNotification()">
                                        <span class="plusIcon cil-plus"></span>
                                        {{this.getLanguage['BTN']['SV']}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>

                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div v-if="bool_showUser">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div class="popupWindow">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="10">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["ASN"]["ESN"]}}</h4>
                                    </CCol>
                                    <CCol col="2">
                                        <CButton id="btn-close1" class="float-right" @click="bool_showUser = !bool_showUser">
                                            <CIcon name=cilX></CIcon>
                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <div class="modal-main-content">
                                    <CRow>
                                        <CCol md="6">
                                            <label class="col-form-label-sm">{{this.getLanguage['ASN']['NT']}} :</label>
                                            <CInput vertical size="sm" :value="str_title" :disabled="true" />
                                        </CCol>
                                    </CRow>

                                    <CRow>
                                        <CCol>
                                            <label class="col-form-label-sm">{{this.getLanguage['ASN']['NC']}} :</label>
                                            <textarea vertical="" rows="6" class="form-control form-control-sm" :value="str_content" :disabled="true" />
                                        </CCol>
                                    </CRow>

                                    <CRow v-if="arry_userList.length > 0">
                                        <CCol md="12" class="pt-3">
                                            <table class="custom-table custom-table-inPopUp afb-blue">
                                                <thead>
                                                    <tr>
                                                        <th style="width: 60px;">{{this.getLanguage["GL"]["NO"]}}</th>
                                                        <th>{{this.getLanguage['ASN']['BN']}}</th>
                                                        <th>{{this.getLanguage['ASN']['RC']}}</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(data,index) in arry_userList">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ data.GN }} ({{ data.PC }})</td>
                                                        <td>{{ data.SC }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </CCol>
                                    </CRow>
                                </div>
                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class="pageHeader position-relative">
                        <h2 id="titleHeight">{{this.getLanguage['SMB']['SNT']}}</h2>
                        <CButton size="sm"
                                 color="outline-info"
                                 data-toggle="NewsAddmodal"
                                 data-target="#myModal"
                                 v-if="checkModuleAccess2(constAccessType.add)"
                                 @click="addNotification()">
                            <span class="plusIcon cil-plus"></span>{{this.getLanguage['BTN']['AN']}}
                        </CButton>

                        <div class="custom-tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="custom-tooltiptext" style=" left: auto;right:0%; bottom: -130%;" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>

                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class="searchBox">
                            <div class="searchCol">
                                <span class="searchLabel">{{this.getLanguage['DM']['SD']}} {{this.getLanguage['DM']['AGI']}} :</span>
                                <customtreeselect :multiple="false"
                                                  :options="dd_agentgroupfs"
                                                  :flat="true"
                                                  :defaultExpandLevel="Infinity"
                                                  :placeholder="this.utilGetDDLanguage('GL.AGT')"
                                                  v-model="str_FV[0].FV"
                                                  @input="AgentGroupChangefs" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['ASN']['CT']}} :</span>
                                <CInput size="sm" :value="str_FV[1].FV" @change="v => str_FV[1].FV = v"></CInput>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["SD"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.startDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage["GL"]["ED"]}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="str_FV[2].FV"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="str_FV[2].FV.endDate != ''">
                                            <CInput size="sm"
                                                    :value="str_FV[2].FV.endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>
                        <div class="searchBtnCol">
                            <CButton class="searchBtn" size="sm" block color="success" ref="search" v-shortkey="['enter']" @shortkey="newSearch()" @click="newSearch()">
                                <span class="searchIcon cil-search"></span>
                                <span>{{this.getLanguage["BTN"]["SR"]}}</span>
                            </CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>

            <div class="table-wrapper">
                <header class="table-header">
                    <strong>
                        {{this.getLanguage['ASN']['SNL']}}
                        <CButton size="sm" color="outline-danger" v-if="checkModuleAccess2(constAccessType.delete) && deleted_items!=null && deleted_items.length>0" @click="deleteNotifications()" style="padding:2px;font-size:12px;min-width:60px">
                            <span class="fa fa-times"></span>{{this.getLanguage['BTN']['DLT']}}
                        </CButton>
                    </strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class="custom-table afb-blue">
                        <thead>
                            <tr>
                                <th style="text-align:center" v-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 1"> </th>
                                <th style="text-align:center" v-else-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 0"><input type="checkbox" v-model="checkAll" @change="selectAll()" style="width:15px;height:15px;" /></th>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage['ASN']['SB']}}</th>
                                <th>{{this.getLanguage['ASN']['SD']}} <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th maxwidth="300px">{{this.getLanguage['ASN']['NT']}}<i @click="setSortTable('T')" :class="setSortLogo('T')" class="sortlogo"></i></th>
                                <th maxwidth="300px">{{this.getLanguage['ASN']['CT']}}</th>
                                <th>{{this.getLanguage['ASN']['RC']}}</th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class="custom-table afb-blue">
                        <thead>
                            <tr>
                                <th style="text-align:center" v-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 1"> </th>
                                <th style="text-align:center" v-else-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 0"><input type="checkbox" v-model="checkAll" @change="selectAll()" style="width:15px;height:15px;" /></th>
                                <th>{{this.getLanguage["GL"]["NO"]}}</th>
                                <th>{{this.getLanguage['ASN']['SB']}}</th>
                                <th>{{this.getLanguage['ASN']['SD']}} <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th maxwidth="300px">{{this.getLanguage['ASN']['NT']}}<i @click="setSortTable('T')" :class="setSortLogo('T')" class="sortlogo"></i></th>
                                <th maxwidth="300px">{{this.getLanguage['ASN']['CT']}}</th>
                                <th>{{this.getLanguage['ASN']['RC']}}</th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arry_al.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arry_al">
                            <td v-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 1 && data.AGI == curAGI">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete)" class="custom-tooltip">
                                        <input type="checkbox" :id="data.I" :value="data.I" v-model="deleted_items" style="width:15px;height:15px;">
                                    </div>
                                </span>
                            </td>
                            <td v-else-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 1 && data.AGI != curAGI">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete)" class="custom-tooltip">
                                    </div>
                                </span>
                            </td>
                            <td v-else-if="(checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)) && isSENS == 0">
                                <span id="actionBtnCol">
                                    <div v-if="checkModuleAccess2(constAccessType.delete)" class="custom-tooltip">
                                        <input type="checkbox" :id="data.I" :value="data.I" v-model="deleted_items" style="width:15px;height:15px;">
                                    </div>
                                </span>
                            </td>
                            <td>{{ CountItem(index+1) }}</td>
                            <td>
                                <span class="grid-line">{{data.GN}}({{data.PC}})</span>
                                <span class="grid-line">{{data.CB}}</span>
                            </td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ substrContent(data.T,25) }}</td>
                            <td>{{ substrContent(data.CBD,40) }}</td>

                            <td class='kema-eft' @click="editNotification(data.I)">
                                <span class="grid-line">{{getLanguage["GL"]["VD"]}}</span>
                            </td>
                            <!-- <td class='kema-eft' @click="showUser(data.ReceiVer,data.T,data.CBD)">
                            <span class="grid-line">{{ data.ReceiVer.length }}</span>
                        </td> -->
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DateRangePicker from "vue2-daterange-picker";
import Treeselect from "@riophae/vue-treeselect";
import { customtreeselect } from '@/views/CustomControl/index.js';
import moment from "moment";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import genericHelper from "@/modules/GenericHelper.js";
import { required, minLength, between, url } from "vuelidate/lib/validators";
import Axios from "axios";
import { constAccessType, loadingFullScreen } from '@/modules/Constant.js';
import Vue from 'vue'
import $ from 'jquery'
//Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            DateRangePicker,
            Loading
        },
        data() {
            return {
                bool_CV: false,
                int_RC: 100, //Row Count
                int_Total: 0,
                int_Page: 1,
                int_IC: 1, // Item Count
                int_TP: 1, //Total Page
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                bool_isEdit: true,
                bool_showSearchBar: true,
                str_FV: [
                    { F: "AGI" },
                    { F: "C" },
                    { F: "CTS", FV: {
                        startDate: "",
                        endDate: ""
                    } },
                ], //Filter Value
                bool_showUser: false,
                bool_isEx: false, // Expend
                bool_isTMV: false, // Table Modal Visible
                bool_isAMV: false, // Add Modal Visible
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_SentAll: false,
                arry_al: [], //Notification List
                obj_aa: [],
                dd_agentgroupfs: [],
                dd_agentgroup: [],
                dd_do: [],
                hodDI: null,
                selectedFile: null,
                str_title:"",
                str_content:"",
                arry_userList: [],
                addLanguage: null,
                constAccessType: constAccessType,
                deleted_items: [],
                checkAll: false
            };
        },
        validations: {
            obj_aa: {
                AGIT: { required },
                T: { required },
                CBD: { required }
            },

        },
        computed: {
            ...mapGetters("Language", ["getLanguage"]),
            ...mapGetters('UserInfo', ['checkModuleAccess']),
            ...mapGetters('UserInfo', ['getUserInfo']),
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getNotificationList();
            },
        },
        methods: {
            DateTimeChange(type, event){
                if(type=="SD"){
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if(dateObj != "Invalid Date" && event != ""){
                        this.str_FV[2].FV.startDate = dateObj;
                    }
                    else if(event != ""){
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    }else{
                        this.str_FV[2].FV.startDate = "";
                    }
                }
                if(type=="ED"){
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if(dateObj != "Invalid Date" && event != ""){
                        this.str_FV[2].FV.endDate = dateObj;
                    }
                    else if(event != ""){
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    }else{
                        this.str_FV[2].FV.endDate = "";
                    }
                }
            },
            TextValueChange(type, event){
                if(type=="CBD"){
                    this.obj_aa.CBD = event.target.value;
                }
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('MNT', 'AN', type);
            },
            closeAdd() {
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            showUser(item,title,content) {
                this.bool_showUser = true;
                this.arry_userList = item;
                this.str_title = title;
                this.str_content = content;
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }                        
                this.int_IC = this.int_Page;                
                this.getNotificationList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getNotificationList();
                }
            },
            returnAGI(value) {
                if (value != null) {
                    var agi = value.split("-");
                    agi = agi[1];
                    return agi;
                }
                else {
                    return null;
                }
            },
            getDropdownList() {
                var that = this;

                this.bool_fullLoading = true;

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroupfs = that.deepClone(d.dropdownlist);

                            //if (that.dd_agentgroupfs.length > 0) {
                            //    that.dd_agentgroupfs.forEach(that.disableAgentGroupParent);
                            //}

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.dd_agentgroup.length > 0) {
                                that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            }

                        }
                    });
            },
            disableAgentGroupParent(item, index) {
                var agi = item.id.split("-");
                if (agi[0] != "3") {
                    item.isDisabled = true;
                }

                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.disableAgentGroupParent);
                }
            },
            get_DD_Add() {
                var that = this;
                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {
                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            if (that.getUserInfo.ISENS == 1) {
                                that.dd_agentgroup = that.dd_agentgroup.filter(f => f.id == "3-" + that.getUserInfo.AGI);
                            }

                            //var agi = [];
                            if (that.dd_agentgroup[0].children == undefined) {
                                agi.push(that.dd_agentgroup[0].id);

                            }
                            //that.obj_aa.AGIT = agi;


                        }
                    });

                if (this.bool_isEdit) {
                    if (this.dd_agentgroup.length > 0) {
                        this.dd_agentgroup.forEach(this.DisableAll);
                    }
                }
            },
            AgentGroupChangefs(value) {

                if (value != undefined) {
                    var agi = 0;

                    if (value != "") {
                        agi = value.split("-")[1];
                        this.searchPAgi = agi;
                    } else {
                        this.searchPAgi = 0;
                    }
                } else {
                    this.searchPAgi = 0;
                    this.str_FV[11].FV = null;
                }
                this.str_FV[1].FV = null;
                this.dd_currency_s = null;
                this.getCurrencyList();
            },
            DisableAll(item, index) {
                item.isDisabled = true;
                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.DisableAll);
                }
            },
            setSortTable(SV) {
                //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort; //change Ascending or Descending ,and then goto the {watch:/bool_isTAD}
                this.getNotificationList();
            },
            setSortLogo(str_TF) {
                return `cil-${
                    this.str_tableSortBy == str_TF
                        ? this.bool_isSort
                            ? "sort-descending"
                            : "sort-ascending"
                        : "list"
                    }`; //here change the sort logo
            },
            getNotificationList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(
                    this.int_Page,
                    this.int_RC,
                    this.str_tableSortBy,
                    this.bool_isSort
                );
                for (var i = 0; i < this.str_FV.length; i++) {

                    if (this.str_FV[i].FV) {
                        if (path) {
                            path += "&";
                        }
                        if (this.str_FV[i].F == "AGI") {
                            path += "f[AGI]=" + this.returnAGI(this.str_FV[i].FV);

                        } else if (this.str_FV[i].F == 'CTS' && this.str_FV[i].FV != '') {
                            if (this.str_FV[i].FV.startDate != "") {
                                var cts_from = this.parseDateToJsonString(this.str_FV[i].FV.startDate);
                                path += "&f[CTS_from]=" + cts_from;
                            }
                            if (this.str_FV[i].FV.endDate != "") {
                                var cts_to = this.parseDateToJsonString(this.str_FV[i].FV.endDate);
                                path += "&f[CTS_to]=" + cts_to;
                            }
                        }
                        else {
                            path += "f[" + this.str_FV[i].F + "]=" + this.str_FV[i].FV;
                        }
                    }
                }
                this.getDataApi(`/api/anotif/l?${path}`, function (d, s) {
                    that.bool_fullLoading = false;
                    if (s) {
                        that.setNotificationList(d.D);
                        that.resizeTableHead();
                    }
                });
            },
            setNotificationList(data) {
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_Total = data.TotalItems;
                this.arry_al = data.Items;
                this.deleted_items = [];
                this.checkAll = false;
            },

            addNotification() {
                this.obj_aa = {
                    ID: 0,
                    RS: 1,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    T: null,
                    CBD: null,
                    SAGI: [],
                    AGIT: [],
                };
                this.bool_isEdit = false;
                this.get_DD_Add();
                this.bool_SentAll=false;
                this.bool_isAMV = true;
                this.bool_CV = false;
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_aa[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["ASN"][langKey]);
                    }
                }

            },
             SetAGIT(item, index) {
                 this.obj_aa.AGIT.push(item.id)
                if (item.children && item.children.length > 0) {
                    item.children.forEach(this.SetAGIT);
                }
            },
            saveNotification() {
                this.bool_fullLoading = true;
                this.bool_CV = true;
                // check if schedule is set
                if(this.bool_SentAll){
                    this.obj_aa.AGIT= [];
                   this.dd_agentgroup.forEach(this.SetAGIT);

                }

                this.$v.obj_aa.$touch();
                for (var i = 0; i < this.obj_aa.AGIT.length; i++) {
                    if (this.obj_aa.AGIT[i] != "" && this.obj_aa.AGIT[i] != null) {
                        var agi = this.obj_aa.AGIT[i].split("-");
                        this.obj_aa.SAGI[i] = agi[1];
                    }
                }
                var that = this;
                if (!this.$v.obj_aa.$error) {
                    this.postDataApi(`/api/anotif/s`, this.obj_aa, function (d, s) {
                        that.bool_isAMV = false;
                        if (s) {
                            that.getNotificationList();
                        }
                    });


                } else {
                    this.bool_fullLoading = false;
                    //find out the unfilled and required inputm then focus it.
                    const validation = this.$v["obj_aa"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            //View Details
            editNotification(id, AR) {
                this.bool_fullLoading = true;
                this.bool_fullScreen = true;
                var that = this;
                this.getDataApi(`/api/anotif/g/${id}`, function (d, s) {
                    that.bool_fullLoading = false;
                    that.bool_fullScreen = false;
                    if (s) {
                        that.bool_isEdit = true;
                        
                        that.setNotification(d.D);
                    }
                });
            },
            setNotification(data) {
                this.showUser(data.RAGI,data.T,data.CBD)
                // this.get_DD_Add();
                // this.obj_aa = data;
                //  var agi = [];
                // if (this.obj_aa.RAGI != null && this.obj_aa.RAGI.length > 0) {
                //     for (var i = 0; i < this.obj_aa.RAGI.length; i++) {
                //         agi.push(this.obj_aa.RAGI[i].AT + "-" + this.obj_aa.RAGI[i].AGI)
                //     }
                // }
                // this.obj_aa.AGIT = agi;

                // // for (var i = 0; i < this.obj_aa.RAGI.length; i++) {
                // //     if (this.obj_aa.RAGI[i] != null) {
                // //         this.obj_aa.RAGI[i] = "3-" + this.obj_aa.RAGI[i];
                // //     }
                // // }
                // // this.obj_aa.AGIT = this.obj_aa.RAGI
                // this.bool_isAMV = true;

            },
            clearDateRangeFilter() {
                this.str_FV[2].FV = {
                    startDate: "",
                    endDate: ""
                };
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            deleteNotifications() {
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        this.postDataApi(`/api/anotif/md`, this.deleted_items,
                            function (d, s) {
                                that.bool_fullLoading = false;

                                if (s) {
                                    that.getNotificationList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            selectAll() {
                this.deleted_items = [];
                if (this.checkAll) {
                    this.arry_al.forEach((value, key) => {
                        this.deleted_items.push(value.I);
                    });
                } 
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        created() {
            this.$parent.showSubMenu = "AN";
            this.$parent.showActiveMenu = "AN.SNT";
            this.getNotificationList();
            this.getDropdownList();
            this.isSENS = this.getUserInfo.ISENS;
            this.curAGI = this.getUserInfo.AGI;
        },
    };
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/SideMenu/Announcement/SystemNotification.vue